// extracted by mini-css-extract-plugin
module.exports = {"inputs":"style_inputs__TmX0H","controls":"style_controls__3koCQ","actions":"style_actions__Bo5_t"};